import React, { useState, useRef } from "react";
import { ICONS, useOnClickOutside } from "../../helpers/helper";

const DropDown = (props) => {
  const { className, items, selectedItems = [], onChange, title, isMulti = false, isForced = false } = props;

  const handleSelectTag = (tag) => {
    let newTags = [...selectedItems];
    if (selectedItems.indexOf(tag.value) < 0) {
      newTags = isMulti ? [...selectedItems, tag.value] : [tag.value];
    } else if(!isForced){
      newTags = selectedItems.filter((t) => t !== tag.value);
    }
    onChange([...newTags]);
  };

  const [isOpen, setIsOpen] = useState(false)
  const ref = useRef();
  useOnClickOutside(ref, (e) => {
    setIsOpen(false)
  });

  return (
    <div ref={ref} className={`cbmap-dropdown ${className || ''} ${isOpen ? 'is-open' : ''} ${selectedItems.length > 0 ? 'cbmap-selected' : ''}`}>
      <div className="cbmap-dropdown-handle" onClick={e => (setIsOpen(!isOpen))}>
        <div className="cbmap-dropdown-title" 
          dangerouslySetInnerHTML={{__html: (title || 'Show filters')}}
        />
        <div
            className="cbmap-caret"
            dangerouslySetInnerHTML={{ __html: ICONS.CARET }}
          />
      </div>
      <div className="cbmap-dropdown-menu">
      {items.map((tag, idx) => (
          <div
            key={`${idx}-${tag.label}`}
            className={`cbmap-dropdown-item ${
              selectedItems.indexOf(tag.value) >= 0 ? "is-selected" : ""
            }`}
            onClick={(e) => handleSelectTag(tag)}
          >
            {tag.label}
            <span className="cbmap-icon-checked" dangerouslySetInnerHTML={{__html: ICONS.CHECKED}}>
            </span>
          </div>
        ))}
      
      </div>
    </div>
  )
}

export default DropDown